import { render, staticRenderFns } from "./EdicaoBoleto.vue?vue&type=template&id=65b5641a&scoped=true&"
import script from "./EdicaoBoleto.vue?vue&type=script&lang=js&"
export * from "./EdicaoBoleto.vue?vue&type=script&lang=js&"
import style0 from "./EdicaoBoleto.vue?vue&type=style&index=0&id=65b5641a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b5641a",
  null
  
)

export default component.exports